export default "__VITE_PUBLIC_ASSET__8fd3c46a__"